import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=4ed94c6a&scoped=true&"
import script from "./Cookies.vue?vue&type=script&lang=ts&"
export * from "./Cookies.vue?vue&type=script&lang=ts&"
import style0 from "./Cookies.vue?vue&type=style&index=0&id=4ed94c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed94c6a",
  null
  
)

export default component.exports